/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronicline.com | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
$(function () {
  function initAssemblyCards(sectionId) {
    var $swiperEl = $('.js-assembly-swiper-' + sectionId);
    if (!$swiperEl.length) return;

    var $section = $swiperEl.closest('.desk_assembly-cards');

    new Swiper($swiperEl[0], {
        slidesPerView: 'auto',
        spaceBetween: 16,
        grabCursor: true,
        speed: 300,
        resistanceRatio: 0.85,
        touchRatio: 1,
        touchAngle: 45,
        threshold: 3,
        followFinger: true,
        touchStartPreventDefault: false,
        touchMoveStopPropagation: false,
        nested: true,
        edgeSwipeDetection: true,
        edgeSwipeThreshold: 20,
        watchSlidesProgress: true,
        freeMode: {
          enabled: true,
          momentum: true,
          momentumRatio: 0.4,
          momentumVelocityRatio: 1,
          momentumBounce: false,
          sticky: false,
          minimumVelocity: 0.02,
        },
        cssMode: false,
        keyboard: { enabled: true, onlyInViewport: true },
        mousewheel: { forceToAxis: true, sensitivity: 0.5, releaseOnEdges: true },
        navigation: {
            prevEl: '.js-assembly-prev-' + sectionId,
            nextEl: '.js-assembly-next-' + sectionId,
        },
        pagination: {
            el: '.js-assembly-pagination-' + sectionId,
            clickable: true,
        },
        breakpoints: {
            1279: { spaceBetween: 24 }
        },
      on: {
        init: function () {
          $section.toggleClass('is-scrollable', !this.isLocked);

          if ($(window).width() <= 800) return;

          ScrollReveal().reveal('.js-assembly-swiper-' + sectionId + ' .desk_assembly-cards__card', {
            origin: 'bottom',
            distance: '20px',
            duration: 700,
            delay: 0,
            easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
            opacity: 0,
            scale: 1,
            once: true,
            interval: 40,
            afterReveal: function (el) {
              $(el).css({ visibility: '', opacity: '', transform: '' });
              ScrollReveal().clean(el);
            }
          });
        },
        resize: function () {
          $section.toggleClass('is-scrollable', !this.isLocked);
        },
        slideChange: function () {
          if ($(window).width() <= 800) return;
          var swiper = this;
          $(swiper.slides).each(function (i, slide) {
            if ($(slide).css('opacity') === '0') {
              $(slide).css({
                transition: 'none',
                opacity: 1,
                transform: 'translateY(0)',
                visibility: 'visible'
              });
              ScrollReveal().clean(slide);
            }
          });
        }
      }
    });

    function openVideoPopup(popupId) {
      var $popup = $('#' + popupId);
      if (!$popup.length) return;
      var popUp = $popup[0];
      // Move the overlay to <body> so its position:fixed covers the full
      // viewport instead of being trapped inside the (short) section.
      if (popUp.parentElement !== document.body) document.body.appendChild(popUp);
      var videoEl = popUp.querySelector('video');
      if (videoEl && !popUp.dataset.loaded) {
        var sources = popUp.querySelectorAll('source[data-src]');
        for (var i = 0; i < sources.length; i++) {
          sources[i].src = sources[i].getAttribute('data-src');
        }
        videoEl.load();
        popUp.dataset.loaded = 'true';
      }
      $popup.addClass('active');
      $('body').addClass('popup-open');
      if (window.lenis) window.lenis.stop();
      if (videoEl) setTimeout(function () { videoEl.play(); }, 300);
    }

    function closeVideoPopup($popup) {
      if (!$popup.length) return;
      $popup.removeClass('active');
      $('body').removeClass('popup-open');
      if (window.lenis) window.lenis.start();
      var videoEl = $popup[0].querySelector('video');
      if (videoEl) videoEl.pause();
    }

    $swiperEl.on('click', '.video_trigger', function () {
      openVideoPopup($(this).attr('data-video-popup'));
    });

    $(document).on('click', '.assembly-video-popup__close', function () {
      closeVideoPopup($(this).closest('.assembly-video-popup'));
    });

    $(document).on('click', '.assembly-video-popup', function (e) {
      if (!$(e.target).closest('.assembly-video-popup__inner').length) {
        closeVideoPopup($(this));
      }
    });

    $(document).on('keydown', function (e) {
      if (e.key === 'Escape') closeVideoPopup($('.assembly-video-popup.active'));
    });
  }

  if ($(window).width() > 800) {
    ScrollReveal().reveal('.desk_assembly-cards', {
      origin: 'bottom',
      distance: '20px',
      duration: 700,
      delay: 0,
      easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
      opacity: 0,
      scale: 1,
      once: true
    });
  }

  var instances = window.DeskAssemblyCards || {};
  $.each(instances, function (id) {
    initAssemblyCards(id);
  });
});